import type { ListResponse } from '../../goodstack'
import type { GivingCampaignOverviewDto } from '../campaign.types'

import type { InfiniteQueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'
import type { GetCampaignsByGroupIdQueryParams } from './getCampaignsByGroupId.types'

export const getCampaignsByGroupId: InfiniteQueryFn<
  [string, string, GetCampaignsByGroupIdQueryParams],
  string,
  ListResponse<GivingCampaignOverviewDto>
> = async (client, [_, groupId, { direction = 'ASC', pageSize = 25, ...params }], cursor) => {
  const { data } = cursor
    ? await client.get<ListResponse<GivingCampaignOverviewDto>>(cursor, {
        withCredentials: true
      })
    : await client.get<ListResponse<GivingCampaignOverviewDto>>(`v1/giving-campaign-group/${groupId}`, {
        params: { direction, pageSize, ...params },
        withCredentials: true
      })

  return data
}
